const ativa1 = {
    medicoCrm: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    medicoNome: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    medicoEstado: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorAceiteprograma: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
  }
}

const ativa2 = {
    consumidorAceiteprograma: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    }
}

const ativa3 = {
    medicoCrm: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    medicoNome: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    medicoEstado: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorAceiteprograma: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    }
}

const ativa4 = {
    consumidorAceiteprograma: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorNome: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDataNascimento: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorSexo: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDddCelular: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorCelular: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },    
    consumidorCep: {
        length: {
            minimum: 8,
            maximum: 8,
            message: "inválido."
        },
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorEstado: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorCidade: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorBairro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorBairro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorTipoLogradouro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorLogradouro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorNumero: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDddTelefone: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorTelefone: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorEmail: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    }
}

const ativa5 = {
    medicoCrm: {
        presence: {
            message: "^Você deve aceitar os termos do programa"
        }
    },
    medicoNome: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    medicoEstado: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorAceiteprograma: {
        presence: {
            message: "^Você deve aceitar os termos do programa"
        }
    },
    consumidorNome: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDataNascimento: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorSexo: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDddCelular: {
        length: {
            minimum: 2,
            maximum: 2,
            message: "inválido."
        },
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorCelular: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorCep: {
        length: {
            minimum: 8,
            maximum: 8,
            message: "inválido."
        },
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorEstado: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorCidade: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorBairro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorBairro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorTipoLogradouro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorLogradouro: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorNumero: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorDddTelefone: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorTelefone: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    },
    consumidorEmail: {
        presence: {
            message: '^Preenchimento é obrigatório.'
        }
    }    
}

export const constraints = {
    ativa1: ativa1,
    ativa2: ativa2,
    ativa3: ativa3,
    ativa4: ativa4,
    ativa5: ativa5
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-seven/pbm-seven.constraints.js